import { message, Modal } from 'antd';
import { FlexCol } from '../../../components/common/common';
import { FC, useState } from 'react';
import { SenseMode } from '../../../types/types';
import MeasurementParameters from '../../../components/widgets/Parameters/MeasurementParameters';
import TimingParameters from '../../../components/widgets/Parameters/TimingParameters';

type PlanParametersModalProps = {
  // modal parameters
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSenseMode: React.Dispatch<React.SetStateAction<SenseMode>>;

  // Measurement metadata
  measurementName: string;
  setMeasurementName: React.Dispatch<React.SetStateAction<string>>;

  descriptionName: string;
  setDescriptionName: React.Dispatch<React.SetStateAction<string>>;

  isAutoSavedMeasurementEnabled: boolean;
  setIsAutoSavedMeasurementEnabled: React.Dispatch<React.SetStateAction<boolean>>;

  isRecordingCalibrantEnabled: boolean;
  setIsRecordingCalibrantEnabled: React.Dispatch<React.SetStateAction<boolean>>;

  baselineDuration: number;
  setBaselineDuration: React.Dispatch<React.SetStateAction<number>>;

  analyteDuration: number;
  setAnalyteDuration: React.Dispatch<React.SetStateAction<number>>;

  desorptionDuration: number;
  setDesorptionDuration: React.Dispatch<React.SetStateAction<number>>;

  // Multiplicator factor
  multiplicatorFactor: number;
  setMultiplicatorFactor: React.Dispatch<React.SetStateAction<number>>;
};

export const PlanParametersModal: FC<PlanParametersModalProps> = ({
  isOpen,
  setIsOpen,
  setSenseMode,
  measurementName,
  setMeasurementName,
  descriptionName,
  setDescriptionName,
  isAutoSavedMeasurementEnabled,
  setIsAutoSavedMeasurementEnabled,
  isRecordingCalibrantEnabled,
  setIsRecordingCalibrantEnabled,
  baselineDuration,
  setBaselineDuration,
  analyteDuration,
  setAnalyteDuration,
  desorptionDuration,
  setDesorptionDuration,
  multiplicatorFactor,
  setMultiplicatorFactor,
}) => {
  const onOk = async () => {
    setIsOpen(false);
    message.success('Saved plan parameters !');
  };

  const onCancel = async () => {
    setIsOpen(false);
    setSenseMode(SenseMode.Recording);
  };
  return (
    <Modal title="New Timed Acquisition" open={isOpen} onCancel={onCancel} onOk={onOk}>
      <FlexCol>
        <MeasurementParameters
          senseMode={SenseMode.TimedRecording} // always display timedParameters as PlanParameterModal opens when the user gets to TimedAcquisition
          isAutoSavedMeasurementEnabled={isAutoSavedMeasurementEnabled}
          setIsAutoSavedMeasurementEnabled={setIsAutoSavedMeasurementEnabled}
          measurementName={measurementName}
          setMeasurementName={setMeasurementName}
          descriptionName={descriptionName}
          setDescriptionName={setDescriptionName}
          isRecordingCalibrantEnabled={isRecordingCalibrantEnabled}
          setIsRecordingCalibrantEnabled={setIsRecordingCalibrantEnabled}
          multiplicatorFactor={multiplicatorFactor}
          setMultiplicatorFactor={setMultiplicatorFactor}
        />
        {/* ================= Timing Parameters ================= */}
        <TimingParameters
          baselineDuration={baselineDuration}
          setBaselineDuration={setBaselineDuration}
          analyteDuration={analyteDuration}
          setAnalyteDuration={setAnalyteDuration}
          desorptionDuration={desorptionDuration}
          setDesorptionDuration={setDesorptionDuration}
        />
      </FlexCol>
    </Modal>
  );
};
